/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Company_HeadingInputs */

const ja_playdata_company_heading = /** @type {(inputs: Playdata_Company_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社概要`)
};

const en_playdata_company_heading = /** @type {(inputs: Playdata_Company_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Details`)
};

/**
* | output |
* | --- |
* | "Company Details" |
*
* @param {Playdata_Company_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_company_heading = /** @type {((inputs?: Playdata_Company_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Company_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_company_heading(inputs)
	return en_playdata_company_heading(inputs)
});